.root {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  overflow: hidden;
  background-color: #fff;
}

.lightbox {
  background-color: #212121;
}

.lightboxHeader {
  position: absolute;
  width: 90%;
  display: flex;
  flex-direction: column;
}

.lightboxTitle {
  color: #fff;
}

.lightboxSubtitle {
  color: rgba(255, 255, 255, 0.5);
}

.lightboxCloseButton {
  position: absolute;
  z-index: 1;
  top: 16px;
  right: 10px;
  color: #fff;
  opacity: 0.5;
  transform: scale(1.3);
}

.lightboxStepper {
  justify-content: flex-end;
  padding: 16px;
  color: rgba(255, 255, 255, 0.5);
}

.lightboxSlide {
  position: relative;
  height: 100vh;
}

.lightboxSlideImg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.date {
  position: absolute;
  left: 16px;
  bottom: 16px;
  color: rgba(255, 255, 255, 0.5);
}

.gridlist {
  margin-left: 8px !important;
  margin-right: 8px !important;
}

.gridlistSubheader {
  z-index: 0;
}

.gridlistTile {}

.img {
  border-radius: 10px;
}

.subheaderText {
  color: #212121;
  font-weight: 500;
}

.divider {
  margin-top: -8px;
  margin-bottom: 8px;
  background-color: #e5e5e5;
}
